import React from 'react'

import ButtonWithIcons from './ButtonWithIcons/ButtonWithIcons'
import SimpleButton from './SimpleButton/SimpleButton'


const Button = (props) => {
  const { leftIcon, rightIcon, ...rest } = props

  if (leftIcon || rightIcon) {
    return <ButtonWithIcons {...props} />
  }

  return <SimpleButton {...rest} />
}

Button.propTypes = ButtonWithIcons.propTypes


export default Button
